<template>
	<div grey-back class="pb-4">
		<!-- <v-btn @click="scroll">scroll</v-btn> -->
		<v-list subheader v-for="(category, index) in listCategories" :key="index" nopadding :class="{'margin-top-ten': index!=0}">
          <v-subheader light subheader-semi-dense>{{category.name}}</v-subheader>
          <v-divider></v-divider>
          <v-list-tile v-for="(item, itemIndex) in category.items" :key="itemIndex">
            <v-list-tile-content @click="fn_openList(item.routeName, item.uri)">
              <v-list-tile-title v-html="item.title"></v-list-tile-title>
            </v-list-tile-content>

            <v-list-tile-action>
              <v-btn flat icon light color="primary" @click="fn_openForm(item.uri)">
              	<v-icon>add</v-icon>
              </v-btn>
            </v-list-tile-action>

          </v-list-tile>
        </v-list>	

        <!-- <dialog-drive-alert ref="ref_dialogDriveAlert"></dialog-drive-alert> -->
	</div>
</template>

<script>

// import dialogDriveAlert from '../../transactions/forms/dialogs/dialog_drive_alert'
	export default{
		// components:{
		// 	'dialog-drive-alert':dialogDriveAlert
		// },
		data(){
			return{
				"listCategories":[
									{
										"name":"Sales",
										"key":"sales",
										"items":[
											{
												"id":1,
												"key":"order",
												"title":"Order",
												"uri":"transactions/sales/order/items",
												"routeName":""
											},
											{
												"id":2,
												"key":"deliveryChallan",
												"title":"Delivery Challan",
												"uri":"transactions/sales/deliverychallan/items",
												"routeName":""
											},
											{
												"id":3,
												"key":"saleInvoice",
												"title":"Sale Invoice",
												"uri":"transactions/sales/saleinvoice/items",
												"routeName":""
											},
											{
												"id":4,
												"key":"saleReturn",
												"title":"Sale Return",
												"uri":"transactions/sales/salereturn/items",
												"routeName":""
											},
											{
												"id":5,
												"key":"estimateQuotation",
												"title":"Estimate/Quotation",
												"uri":"/transactions/sales/estimate/items",
												"routeName":""
											},
											{
												"id":6,
												"key":"creditNote",
												"title":"Credit Note",
												"uri":"/transactions/sales/creditnote/items",
												"routeName":""
											},
										]
									},
									{
										"name":"Purchase",
										"key":"purchase",
										"items":[
											{
												"id":1,
												"key":"purchaseOrder",
												"title":"Purchase Order",
												"uri":"transactions/purchase/purchaseorder/items",
												"routeName":""
											},
											{
												"id":2,
												"key":"purchaseChallan",
												"title":"Purchase Challan",
												"uri":"transactions/purchase/purchasechallan/items",
												"routeName":""
											},
											{
												"id":3,
												"key":"purchaseInvoice",
												"title":"Purchase Invoice",
												"uri":"transactions/purchase/purchaseinvoice/items",
												"routeName":""
											},
											{
												"id":4,
												"key":"purchaseReturn",
												"title":"Purchase Return",
												"uri":"transactions/purchase/purchasereturn/items",
												"routeName":""
											},
											{
												"id":5,
												"key":"expense",
												"title":"Expense",
												"uri":"/transactions/purchase/expense/items",
												"routeName":""
											},
											{
												"id":6,
												"key":"debitNote",
												"title":"Debit Note",
												"uri":"transactions/purchase/debitnote/items",
												"routeName":""
											},
										]
									},
									{
										"name":"Accounting",
										"key":"accounting",
										"items":[
											{
												"id":1,
												"key":"paymentIn",
												"title":"Payment In",
												"uri":"transactions/receipt/items",
												"routeName":""
											},
											{
												"id":2,
												"key":"paymentOut",
												"title":"Payment Out",
												"uri":"transactions/payment/items",
												"routeName":""
											},
											{
												"id":3,
												"key":"journal",
												"title":"Journal",
												"uri":"transactions/journal/items",
												"routeName":""
											},
											{
												"id":4,
												"key":"cashAndBank",
												"title":"Cash and Bank",
												"uri":"transactions/contra/items",
												"routeName":""
											},
											// {
											// 	"id":5, 
											// 	"title":"Credit Note",
											// 	"uri":"transactions/creditnote/items",
											// 	"routeName":""
											// },
											// {
											// 	"id":5, 
											// 	"title":"Credit Note",
											// 	"uri":"transactions/creditnote/items",
											// 	"routeName":""
											// },
											// {
											// 	"id":6, 
											// 	"title":"Debit Note",
											// 	"uri":"transactions/debitnote/items",
											// 	"routeName":""
											// },
										]
									},
									{
										"name":"Inventory",
										"key":"inventory",
										"items":[
											// {
											// 	"id":1,
											// 	"key":"stockJournal",
											// 	"title":"Stock Journal",
											// 	"uri":"transactions/inventory/stockjournal/items",
											// 	"routeName":""
											// }
											{
												"id":1,
												"key":"stockTransfer",
												"title":"Stock Transfer",
												"uri":"/transactions/inventory/stocktransfer/items",
												"routeName":""
											},
											{
												"id":2,
												"key":"billOfMaterials",
												"title":"Bill of Materials",
												"uri":"/transactions/inventory/billofmaterials/items",
												"routeName":""
											}
										]
									}
								]
			}
		},
		methods:{
			fn_openList: function(routeName, uri){
				this.$router.push({path:uri, query:{tagId:this.guidWeb()}});
			},
			// fn_checkDrive: function(uri){
			// 	let self = this;
			// 	if(this.$root.CurrentBusiness.DataDrive){
			// 		this.fn_openForm(uri);
			// 	}
			// 	else{
			// 		this.$root.fn_getTransactionCount(function(count){
			// 			if(count>=10){
			// 				self.$refs['ref_dialogDriveAlert'].dialog_setup_drive = true;
			// 			}
			// 			else{
			// 				self.fn_openForm(uri);
			// 			}
			// 		})
			// 	}
			// },
			fn_openForm: function(uri){
				localStorage.setItem("SetDataDrive", 1);
				this.$router.push({path:uri+'/new', query:{tagId:this.guidWeb()}});
			}
			// scroll(){
			// 	this.$vuetify.goTo(99999, this.scrollOptions);
			// }
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/actions/contents/transactions.vue